import { useDispatch, useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { selectAccount } from '../../store/auth/auth.selector';
import { useState } from 'react';
import { updateAccountSetting } from '../../store/auth/auth.actions';
import { showFeedback } from '../../store/ui/ui.actions';
import { translate } from '../../lib/lang.helper';
import { Button, Input, Title } from '../../components/shared';

const EagleIOApiKeyInput = () => {
  const dispatch = useDispatch<any>();
  const lang = useSelector(selectLang);
  const eagleIoApiKey = useSelector(selectAccount)?.eagle_io_api_key ?? '';

  const [apiKey, setApiKey] = useState(eagleIoApiKey);
  const [disabled, setDisabled] = useState(false);

  const updateClick = async () => {
    setDisabled(true);
    const res = await dispatch(
      updateAccountSetting({ eagle_io_api_key: apiKey }),
    );
    if (res !== true) {
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'error',
          message: translate(lang, res?.message ?? 'Server error'),
        }),
      );
    }
    setDisabled(false);
  };

  return (
    <div className='mb-24 mt-24'>
      <div className='mb-16'>
        <Title size={6} color='black-3' align='default' fontWeight={500}>
          {translate(lang, 'eagle.io API Key')}
        </Title>
      </div>
      <div className='ml-21'>
        <Input
          type='text'
          value={apiKey}
          onChange={e => setApiKey(e.target.value)}
        />
        <Button
          className='mt-16 mb-16'
          type='fill'
          width='small'
          size={0}
          color='blue'
          onClick={updateClick}
          disabled={disabled}
        >
          {translate(lang, 'Update')}
        </Button>
      </div>
    </div>
  );
};

const ExtensionsPage = () => {
  const lang = useSelector(selectLang);

  return (
    <div className='content pb-32'>
      <Title
        className='mb-24'
        size={5}
        color='black-3'
        align='default'
        fontWeight={600}
      >
        {translate(lang, 'Extensions')}
      </Title>
      <EagleIOApiKeyInput />
    </div>
  );
};

export default ExtensionsPage;
